import script from "./UserPoints.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPoints.vue?vue&type=script&setup=true&lang=ts"

import "./UserPoints.vue?vue&type=style&index=0&id=4e92a6eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e92a6eb"]])

export default __exports__